module.exports = __webpack_public_path__ + "./favicon.5f2675471064c1397a9a4a45607b96b4.ico";